<template>
  <div>
    <h2>Withdrawal request</h2>

    <div v-if="loading">Loading...</div>

    <b-alert
      v-for="(error, index) in errors"
      :key="index"
      show
      variant="danger"
      class="mt-3"
    >
      {{ error.msg }}
    </b-alert>

    <div v-if="withdrawal._id">
      <table class="table">
        <tbody>
          <tr>
            <th>Amount</th>
            <td>${{ (withdrawal.amount / 100).toFixed(2) }}</td>
          </tr>
          <tr>
            <th>Paypal Email</th>
            <td>{{ withdrawal.paypalEmail }}</td>
          </tr>
          <tr>
            <th>Sent</th>
            <td>{{ withdrawal.approvedDate ? true : false }}</td>
          </tr>
          <tr>
            <th>Paypal Identifier</th>
            <td>
              <b-form @submit.prevent="onSubmit">
                <b-form-input
                  v-model.trim="newPaypalIdentifier"
                  :disabled="withdrawal.approvedDate"
                ></b-form-input>
              </b-form>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Modal Component -->
    <b-btn
      :disabled="withdrawal.approvedDate"
      size="sm"
      @click="acceptPaypalIdentifier()"
      >Mark as Sent</b-btn
    >
  </div>
</template>

<script>
import API from '@/api';

export default {
  name: 'WithdrawalDetail',
  props: {
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      errors: [],
      newPaypalIdentifier: '',
      loading: false,
      withdrawal: {},
      alertError: ''
    };
  },
  created() {
    this.loadWithdrawal();
  },
  destroyed() {},
  methods: {
    loadWithdrawal() {
      this.errors = [];
      this.loading = true;
      API.get(`admin/withdrawal/${this.id}`).then(res => {
        this.loading = false;

        if (res.status === 'ok') {
          this.withdrawal = res.data.withdrawal;
          this.newPaypalIdentifier = res.data.withdrawal.paypalIdentifier;
        } else {
          this.errors = this.errors.length
            ? this.errors.concat(res.errors)
            : res.errors;
        }
      });
    },
    acceptPaypalIdentifier() {
      this.errors = [];
      if (!this.newPaypalIdentifier || this.newPaypalIdentifier.length) {
        this.errors = [{ msg: 'Enter PayPal Identifier' }];
      }

      if (!this.newPaypalIdentifier || this.newPaypalIdentifier.length === 0) {
        return;
      }

      API.post(`admin/withdrawal/approve`, {
        id: this.id,
        paypalIdentifier: this.newPaypalIdentifier
      }).then(res => {
        if (res.status === 'ok') {
          this.$router.go(-1);
        } else {
          this.errors = res.errors;
        }
      });
    }
  }
};
</script>

<style scoped></style>
